exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-cont{display:flex;flex-direction:row-reverse;position:absolute;top:5px;right:10px;left:auto;color:red;font-size:.85em;align-items:center;z-index:2}.error-cont .icon{font-size:1em}.error-cont .error-tooltip{position:absolute;background:red;border:1px solid #c00;color:#fff;padding:.25rem;top:10px;right:15px;left:auto;white-space:nowrap;border-radius:2.5px}body[dir=rtl] .error-cont {\n  left: 10px;\n  right: auto;\n}body[dir=rtl] \n.error-cont .error-tooltip {\n  left: 15px;\n  right: auto;\n}\n", ""]);

// exports
